import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import { getService } from '../../services'
import SwitchCustomerService from './SwitchService'
import { useServiceTabs } from './tab'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Detail = () => {
    const { id: serviceID } = useParams()
    const { t } = useTranslation('services')

    const { data: service, renderState } = useQueryWithHandler({
        queryFn: () => getService(Number(serviceID)),
        queryKey: [QUERY_KEYS.SERVICE_DETAIL, Number(serviceID)],
    })
    const { TabProps, TabComponent } = useTabs({
        tabs: useServiceTabs(
            t,
            service?.service_template,
            service?.service_status,
            service?.is_poc
        ),
    })

    if (renderState()) return renderState()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.services,
                        title: t('services'),
                    },
                    {
                        path: generatePathDatacentral(paths.customerDetail, {
                            id: service?.customer_id,
                        }),
                        title:
                            [
                                service?.customer_id,
                                (
                                    service?.company_name ||
                                    service?.customer_name
                                )?.toUpperCase(),
                            ].join(' - ') || '---',
                    },
                    {
                        path: '',
                        title:
                            [
                                service?.product_group_name,
                                service?.service_name?.toUpperCase(),
                            ].join(' - ') || '---',
                    },
                ]}
                components={[
                    <SwitchCustomerService
                        serviceID={service?.service_id as number}
                        customerID={service?.customer_id as number}
                        key={service?.service_id}
                    />,
                ]}
            />
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </>
    )
}

export default Detail
